export interface BetaWelcomeContent {
  title: string;
  lead: string;
  readyItems: string[];
  unstableItems: string[];
  feedbackTitle: string;
  feedbackText: string;
}

export interface BetaWelcomeDmSettings {
  enabled: boolean;
  authorPseudo: string;
  messageTemplate: string;
}

export const DEFAULT_BETA_WELCOME_CONTENT: BetaWelcomeContent = {
  title: 'Bienvenue, bêta-testeur !',
  lead: 'Merci de tester Webtarot Neo en avant-première. Voici l\'essentiel avant de commencer.',
  readyItems: [
    'Connexion, chat global et tables de jeu Neo',
    'Invitations à jouer et reprise après déconnexion',
    'Interface desktop et mobile (best effort)',
  ],
  unstableItems: [
    'Performances variables lors des mises à jour',
    'Quelques écrans peuvent demander un rechargement',
    'Certaines fonctions compétition arrivent progressivement',
  ],
  feedbackTitle: 'Un bug ou une idée ?',
  feedbackText: 'Utilisez le bouton 💬 en bas à droite ou le menu Paramètres → Bêta-test. Décrivez ce que vous faisiez : le contexte est envoyé automatiquement.',
};
